import { CopyTextToClipboardComponent } from './../../../../components/dialogs/copy-text-to-clipboard/copy-text-to-clipboard.component';
import { pathToClosingAssets, serverurl } from './../../../../../environments/environment';
import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { GenericStreamService } from '../../../../service/generic-stream.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ScriptLoaderService } from '../../../../service/script-loader.service';
import { UserdataService } from '../../../../service/userdata.service';
import { MatDialog } from '@angular/material/dialog';
import { EditHtmlImageComponent } from './edit-html-image/edit-html-image.component';
import { closingContentChanges, ClosingContentChangeType } from '../../../../interfaces/responsedata.ts/generic-streams';
import { ShareAssetComponent } from './share-asset/share-asset.component';
import { Router } from '@angular/router';
import { GenAiService } from '../../../../service/gen-ai.service';
import { ClipboardService } from '../../../../service/clipboard.service';
import { UploadService } from '../../../../service/upload.service';
import html2canvas from 'html2canvas';
import { send } from 'process';
import { CreatePdfByHtmlResponse, TextDataObject } from '../../../../interfaces/responsedata.ts/pdf';
import { Orientation } from '../../../../interfaces/responsedata.ts/orientation';



@Component({
    selector: 'app-generic-html-view-standalone',
    standalone: false,
    templateUrl: './generic-html-view-standalone.component.html',
    styleUrl: './generic-html-view-standalone.component.scss'
})
export class GenericHtmlViewStandaloneComponent implements AfterViewInit, OnInit {
    @ViewChild('htmlTemplateView') htmlTemplateViewComponent!: any;
    genService = inject(GenericStreamService);
    readonly sanitizer = inject(DomSanitizer);
    private scriptLoader = inject(ScriptLoaderService);
    private userService = inject(UserdataService);
    aiService = inject(GenAiService);
    dialog = inject(MatDialog);
    router = inject(Router);
    cd = inject(ChangeDetectorRef);
    clipboardService = inject(ClipboardService);
    uploadService = inject(UploadService);

    showDialogHeader: boolean = false;
    editContent: boolean = false;
    isLoading: boolean = false;
    unsavedContent: boolean = false;
    showMenue: boolean = false;

    content: SafeHtml | string = "";
    imgAssets: string[] = [];
    userId: string | undefined;
    streamId: string | undefined;
    stepId: string | undefined;
    prePreparedHtml: string = '';
    globalChanges: closingContentChanges[] = [];
    jsonData: any;
    assetName: string = "ideastream asset";

    ngOnInit(): void {
        // Get data from url snapshot
        let decodedParams = decodeURIComponent(window.location.href);
        if (!decodedParams || decodedParams.indexOf('?') === -1) {
            // Decode again if needed
            decodedParams = decodeURIComponent(decodedParams);
        }
        const urlParams = new URLSearchParams(decodedParams.split('?')[1]);
        this.userId = urlParams.get('uid') || undefined;
        this.streamId = urlParams.get('sid') || undefined;
        this.stepId = urlParams.get('stepid') || undefined;

        this.userService.data.subscribe((userdata) => {
            // console.log('User data changed:', userdata);
            // console.log(this.userId);

            if (this.userId) {
                if (userdata && userdata.id && this.userId === userdata.id) {
                    this.showDialogHeader = true;
                } else {
                    this.showDialogHeader = false;
                }
            }
        });
    }
    async ngAfterViewInit() {

        if (this.streamId && this.stepId && this.userId) {
            this.isLoading = true;
            this.cd.detectChanges();
            let result: any = await this.genService.getHtmlDataByMetaData(this.streamId, this.stepId, this.userId);
            console.log("Result", result);

            if (result === false) {
                this.isLoading = false;
                this.cd.detectChanges();
                return;
            }
            let html;
            this.jsonData = result.data;

            if (result.s3SavedFile === true) {
                html = await this.genService.getHtmlDataByUser(this.streamId, this.stepId, this.userId);
                html = this.doreplacements(html);
                // console.log("===== LOADED FROM S3 ======");

            } else {
                html = await this.genService.getHtmlData(result.variant!);
                // Notewendige Ersetzungen
                html = this.doreplacements(html);

                try {
                    result.data = JSON.parse(result.data as any);
                } catch (error) {
                    // ignore
                }



                let jsonElements = Object.keys(result.data || {});
                for (let key of jsonElements) {
                    const re = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
                    html = html.replace(re, '<span class="editable" contenteditable="false" data-key="' + key + '">' + result.data[key] + '</span>');
                }
            }
            if (!html) {
                this.isLoading = false;
                this.cd.detectChanges();
                return
            }

            // Notewendige Ersetzungen
            html = html
                .replace(/\{\{SERVER_URL\}\}/g, serverurl)
                .replace(/\{\{SERVER_CLOSING_PATH\}\}/g, pathToClosingAssets)
                .replace(/h1,h2,h3,h4,h5,h6,p{font-size:inherit;font-weight:inherit}/g, "");

            try {
                result.data = JSON.parse(result.data);
            } catch (error) {
                // Fehler beim Parsen der JSON-Daten egal bleibt wie es ist
            }

            let jsonElements = Object.keys(result.data || {});
            for (let key of jsonElements) {
                const re = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
                html = html.replace(re, '<span class="editable" contenteditable="false" data-key="' + key + '">' + result.data[key] + '</span>');
            }
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const images = doc.getElementsByTagName('img');


            Array.from(images).forEach((img) => {
                const src = img.getAttribute('src') || '';
                let exists = this.imgAssets.find(i => i === src);
                if (!exists) {
                    this.imgAssets.push(src);
                }
            });

            this.prePreparedHtml = html;
            await this.finalizeHtml(this.prePreparedHtml);

            this.isLoading = false;
            this.cd.detectChanges();
        }
    }

    async exportAsPdf() {
        console.log("starte Screenshot");
        this.showMenue = false;
        this.isLoading = true;

        // Clone the container element instead of the entire document
        const originalContainer = document.querySelector('#container') as HTMLElement;
        if (!originalContainer) {
            throw new Error('Container element not found');
        }

        let nodeCopy = originalContainer.cloneNode(true) as HTMLElement;

        // Create a temporary wrapper
        const tempWrapper = document.createElement('div');
        tempWrapper.style.cssText = 'position: absolute; left: -9999px; top: 0; z-index: -9999;';
        tempWrapper.appendChild(nodeCopy);
        document.body.appendChild(tempWrapper);
        // Clone computed Styles
        const computedStyle = window.getComputedStyle(nodeCopy);
        for (let i = 0; i < computedStyle.length; i++) {
            const key = computedStyle[i];
            nodeCopy.style.setProperty(key, computedStyle.getPropertyValue(key), computedStyle.getPropertyPriority(key));
        }

        let textDat: TextDataObject[] = [];
        // Loop over all elements of tempWrapper and get their position and text content
        tempWrapper.querySelectorAll("*").forEach((el: any) => {
            if (el instanceof HTMLElement) {
                // If element contains Text nodes, extract their data
                el.childNodes.forEach((child: any) => {
                    // console.log("test");

                    if (child.nodeType === Node.TEXT_NODE && child.textContent && child.textContent.trim() !== '') {
                        const range = document.createRange();
                        range.selectNodeContents(child);
                        const rect = range.getBoundingClientRect();

                        let obj: TextDataObject = {
                            content: child.textContent,
                            positionX: rect.left + window.scrollX + 9999,
                            positionY: rect.top + window.scrollY,
                            fontSize: parseFloat(computedStyle.fontSize),
                            fontWeight: computedStyle.fontWeight,
                            color: computedStyle.color,
                            elementWidth: rect.width,
                            elementHeight: rect.height,
                            lineHeight: parseFloat(computedStyle.lineHeight)
                        }
                        textDat.push(JSON.parse(JSON.stringify(obj)));
                    }
                    // console.log("test");
                });
            }
        });




        tempWrapper.querySelectorAll(':not([style*="display"]) > *').forEach((el: any) => {
            if (el instanceof HTMLElement) {

                const computedStyle = window.getComputedStyle(el);
                // Nur relevante CSS-Eigenschaften kopieren statt alle
                const relevantProps = [
                    'width', 'height', 'margin', 'padding', 'border', 'border-radius',
                    'background', 'background-color', 'background-image', 'background-size',
                    'font-size', 'font-family', 'font-weight', 'line-height',
                    'color', 'text-align', 'display', 'position', 'top', 'left', 'right', 'bottom',
                    'flex', 'flex-direction', 'justify-content', 'align-items',
                    'grid', 'grid-template-columns', 'grid-gap'
                ];

                relevantProps.forEach(prop => {
                    const value = computedStyle.getPropertyValue(prop);
                    if (value && value !== '') {
                        el.style.setProperty(prop, value, computedStyle.getPropertyPriority(prop));
                    }
                });



                // Replace object-fit: cover with background-image approach
                if (el.tagName === 'IMG' && (el.style.objectFit === 'cover' || computedStyle.objectFit === 'cover')) {
                    const imgEl = el as HTMLImageElement;
                    const parent = imgEl.parentElement;

                    if (parent) {
                        // Create a div wrapper that will use background-image instead
                        const wrapper = document.createElement('div');
                        wrapper.style.width = computedStyle.width;
                        wrapper.style.height = computedStyle.height;
                        wrapper.style.backgroundImage = `url(${imgEl.src})`;
                        wrapper.style.backgroundSize = 'cover';
                        wrapper.style.backgroundPosition = 'center center';
                        wrapper.style.backgroundRepeat = 'no-repeat';

                        // Copy other relevant styles
                        wrapper.style.borderRadius = computedStyle.borderRadius;
                        wrapper.style.margin = computedStyle.margin;
                        wrapper.style.padding = computedStyle.padding;

                        // Replace the image with the wrapper
                        parent.replaceChild(wrapper, imgEl);
                    }
                }
                el.style.color = 'transparent';
            }
        });
        console.log("Test");

        let canvas: HTMLCanvasElement;
        try {
            canvas = await html2canvas(tempWrapper, {
                useCORS: true,
                logging: true,
                windowWidth: tempWrapper.scrollWidth,
                windowHeight: tempWrapper.scrollHeight,
                allowTaint: true,
            });
        } catch (err) {
            console.error('html2canvas error:', err);
            if (tempWrapper && tempWrapper.parentNode) {
                tempWrapper.parentNode.removeChild(tempWrapper);
            }
            this.isLoading = false;
            return;
        }

        if (tempWrapper && tempWrapper.parentNode) {
            // tempWrapper.parentNode.removeChild(tempWrapper);
        }
        // Create a link to download the image
        let blob = await new Promise<Blob | null>((resolve) => {
            canvas.toBlob(function (blob) {
                resolve(blob);
            }, 'image/png');
        });
        if (blob) {

            let pdf = await this.sendBlobAndDAtaToServer(blob, textDat, Orientation.PORTRAIT);
            if (pdf === false) {
                return;
            }
            // let link = document.createElement('a');
            // link.href = `${serverurl}/knowledgehub/downloadfile/${pdf.filedata.id}`;
            // link.download = this.assetName + '.pdf';
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        }
        this.isLoading = false;
        console.log('finish');




    }
    async sendBlobAndDAtaToServer(blob: Blob, textData: TextDataObject[], orientation: Orientation): Promise<false | CreatePdfByHtmlResponse> {
        let result = await this.uploadService.createPdfByHtml(blob, textData, orientation);
        return result;
    }
    async exportAsMiro() {
        this.showMenue = false;
        this.isLoading = true;
        this.cd.detectChanges();
        let content = JSON.stringify(this.jsonData, null, 2);
        let result = await this.aiService.genAiMiroExportResponseText(content);
        this.isLoading = false;
        this.cd.detectChanges();

        if (result === false) {
            return;
        }

        this.dialog.open(CopyTextToClipboardComponent, {
            autoFocus: false,
            panelClass: 'small-dialog',
            data: { title: "Miro Export", content: result }
        })

    }
    gotologin() {
        this.router.navigate(['/login']);
    }
    async shareAsset() {
        let dia = this.dialog.open(ShareAssetComponent, {
            panelClass: "small-dialog",
            autoFocus: false,
            data: {
                streamId: this.streamId,
                stepId: this.stepId,
                userId: this.userId
            }
        });
    }
    async cancelEdit() {

        this.globalChanges.forEach(change => {

            const parser = new DOMParser();
            const doc = parser.parseFromString(this.prePreparedHtml, 'text/html');
            const element = doc.getElementById(change.elementId);
            console.log(element, change.type);

            if (element && change.type === ClosingContentChangeType.TEXT) {
                element.innerHTML = change.from;
            }

            if (element && change.type === ClosingContentChangeType.IMAGE) {
                element.setAttribute('src', change.from);
                element.removeAttribute('srcset');
                // console.log("Image", element);
            }
            this.prePreparedHtml = doc.documentElement.outerHTML;
        });

        this.unsavedContent = false;
        // this.prePreparedHtml = this.prePreparedHtml.replaceAll('contenteditable="true"', 'contenteditable="false"');
        // this.prePreparedHtml = this.prePreparedHtml.replaceAll('class="editable-active"', 'class="editable"');
        await this.finalizeHtml(this.prePreparedHtml);
    }
    async finalizeHtml(html: string) {
        await this.scriptLoader.processHtmlScripts(html);
        this.content = this.sanitizer.bypassSecurityTrustHtml(html);
    }
    onContentChanged(newContent: { changes: any[], updatedContent: string }) {
        // console.log("newContent");
        this.unsavedContent = true;
        // this.content = newContent.updatedContent;
        this.prePreparedHtml = JSON.parse(JSON.stringify(newContent.updatedContent));
        newContent.changes.forEach(change => {
            let exists = this.globalChanges.find(c => c.elementId === change.elementId);
            if (!exists) {
                this.globalChanges.push(change);
            } else {
                this.globalChanges.forEach((c, index) => {
                    if (c.elementId === change.elementId) {
                        this.globalChanges[index] = change;
                    }
                });
            }
        });
        // this.finalizeHtml(newContent.updatedContent);
    }
    doreplacements(html: string): string {

        html = html
            .replace(/%7B/g, "{")
            .replace(/%7D/g, "}")
            .replace(/%25/g, "%")
            .replace(/%3F/g, "?")
            .replace(/\{\{SERVER_URL\}\}/g, serverurl)
            .replace(/\{\{SERVER_CLOSING_PATH\}\}/g, pathToClosingAssets)
            .replace(/h1,h2,h3,h4,h5,h6,p{font-size:inherit;font-weight:inherit}/g, "");

        return html;

    }
    async editPage() {
        this.editContent = !this.editContent;
        this.unsavedContent = false;

        if (this.editContent === false) {
            this.prePreparedHtml = this.prePreparedHtml.replaceAll('contenteditable="true"', 'contenteditable="false"');
            this.prePreparedHtml = this.prePreparedHtml.replaceAll('class="editable-active"', 'class="editable"');
            await this.finalizeHtml(this.prePreparedHtml);

        } else {
            console.log("**** EDIT CONTENT ACTIVE *****");

            this.prePreparedHtml = this.prePreparedHtml.replaceAll('contenteditable="false"', 'contenteditable="true"');
            this.prePreparedHtml = this.prePreparedHtml.replaceAll('class="editable"', 'class="editable-active"');
        }
        await this.finalizeHtml(this.prePreparedHtml);
    }
    editImage(image: string) {
        const img = this.imgAssets.find(i => i === image);

        if (img) {
            let dia = this.dialog.open(EditHtmlImageComponent, {
                panelClass: "small-dialog",
                autoFocus: false,
                data: {
                    image: img,
                    streamId: this.streamId,
                    stepId: this.stepId
                }
            });
            dia.afterClosed().subscribe(async (result: { oldImageUrl: string, newImageUrl: string } | undefined) => {
                if (result) {
                    this.unsavedContent = true;
                    // console.log(result);


                    this.imgAssets.forEach((img, index) => {
                        if (img === result.oldImageUrl) {
                            this.imgAssets[index] = result.newImageUrl;
                        }
                    });

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(this.prePreparedHtml, 'text/html');
                    const images = doc.getElementsByTagName('img');

                    Array.from(images).forEach((img) => {
                        const src = img.getAttribute('src') || '';
                        if (src.indexOf(result.oldImageUrl) !== -1) {
                            img.setAttribute('src', result.newImageUrl);
                            img.removeAttribute('srcset');

                            if (!img.id || img.id === '') img.id = new Date().getTime().toString();
                            let exists = this.globalChanges.find(c => c.elementId === img.id);
                            if (!exists) {
                                this.globalChanges.push({
                                    time: new Date().getTime(),
                                    type: ClosingContentChangeType.IMAGE,
                                    elementId: img.id,
                                    from: result.oldImageUrl,
                                    to: result.newImageUrl
                                });
                            } else {
                                this.globalChanges.forEach((c, index) => {
                                    if (c.elementId === img.id) {
                                        c.time = new Date().getTime();
                                        c.to = result.newImageUrl;
                                    }
                                });
                            }
                        }
                    });
                    this.prePreparedHtml = doc.documentElement.outerHTML;

                    await this.finalizeHtml(this.prePreparedHtml);
                }
            });
        }
    }
    async saveContent() {
        this.isLoading = true;
        const escapedServerUrl = serverurl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const escapedClosingPath = pathToClosingAssets.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        this.prePreparedHtml = this.doreplacements(this.prePreparedHtml)
            .replaceAll('contenteditable="true"', 'contenteditable="false"')
            .replaceAll('class="editable-active"', 'class="editable"');
        this.prePreparedHtml = this.prePreparedHtml.replace(new RegExp(escapedServerUrl, 'g'), "{{SERVER_URL}}");
        this.prePreparedHtml = this.prePreparedHtml.replace(new RegExp(escapedClosingPath, 'g'), '{{SERVER_CLOSING_PATH}}');

        this.globalChanges.forEach(change => {
            change.from = change.to;
        })

        await this.genService.saveGenricResultContent(this.streamId!, this.stepId!, this.prePreparedHtml, this.globalChanges);

        this.prePreparedHtml = this.prePreparedHtml.replaceAll('contenteditable="false"', 'contenteditable="true"');
        this.prePreparedHtml = this.prePreparedHtml.replaceAll('class="editable"', 'class="editable-active"');
        this.prePreparedHtml = this.doreplacements(this.prePreparedHtml);
        this.globalChanges = [];

        await this.finalizeHtml(this.prePreparedHtml);
        this.unsavedContent = false;
        this.isLoading = false;

        console.log(this.unsavedContent, this.editContent);

    }
}

